module.exports = {
	env: {
		mode: 'stage',
		packageName: 'it.dietasocial.web',
		forceProduction: false, //To void open installation modal
		freeRoutes: true,
		mandatoryInstall: false,
		native: {
			url: 'https://stage.dietasocial.it',
			node: 'https://api.dietasocial.it:3001',
			app: 'https://localhost',
		},
		stage: {
			url: 'https://stage.dietasocial.it',
			node: 'https://api.dietasocial.it:3001',
			app: 'https://sandbox.dietasocial.it',
		},
		local: {
			url: 'http://localhost:14100',
			node: 'https://api.dietasocial.it:3001',
			app: 'https://localhost',
		},
		prod: {
			url: 'https://adoc.dietasocial.it',
			node: 'https://api.dietasocial.it:3001',
			app: 'https://app.dietasocial.it',
		},
	},
}
